import { AdditionalProperty } from 'app/state';

type Override = Pick<
  AdditionalProperty,
  'standardRate' | 'dsoFee' | 'mealPlanFee' | 'mealPlanAvailable'
>;

const rowKey = (row: Pick<AdditionalProperty, 'id' | 'propertyId'>) =>
  row.id ? row.id : row.propertyId;

export const toAdditionalProperty = (
  item: Pick<AdditionalProperty, 'id' | 'propertyId' | 'roomTypeId'>,
  override?: Override
): AdditionalProperty => ({
  id: item.id,
  propertyId: item.propertyId,
  roomTypeId: item.roomTypeId,
  standardRate: override?.standardRate,
  dsoFee: override?.dsoFee,
  mealPlanFee: override?.mealPlanFee,
  mealPlanAvailable: override?.mealPlanAvailable,
});

// Only ticked rows are saved, so entering a value ticks the row; clearing a value never does.
export function applyOverrideToSelection<K extends keyof Override>(
  selected: AdditionalProperty[],
  row: AdditionalProperty,
  field: K,
  value: Override[K]
): AdditionalProperty[] {
  const key = rowKey(row);

  if (selected.some(rate => rowKey(rate) === key)) {
    return selected.map(rate => (rowKey(rate) === key ? { ...rate, [field]: value } : rate));
  }

  return value === undefined ? selected : [...selected, row];
}
